import { FormHeaderBreadCrumb } from "@components/FormBreadCrumb";
import Colors from "@constants/Colors";
import { SectionTitle } from "@modules/talents/components";
import { Stack, Typography } from "@mui/material";

type Props = {
    title?: string;
    breadcrumbs?: (string | { label: string; href: string })[];
    description?: string;
    titleWidth?: number;
    textAlignment?: 'center' | 'left' | 'right';
};

export const FormHeaderProfile = (props: Props) => {
    return (
        <Stack sx={{
            gap: 1,
            marginBottom: {
                xs: 1,
                md: 2,
            }
        }}>
            <SectionTitle title={props.title || ''} />
            {props.breadcrumbs && <FormHeaderBreadCrumb items={props.breadcrumbs} />}
            {props.description && (
                <Typography
                    style={{
                        textAlign: 'left',
                    }}
                    color={Colors.NEUTRAL_GRAY}
                    fontSize={{
                        xs: 14,
                        sm: 16,
                    }}>
                    {props.description}
                </Typography>
            )}
        </Stack>
    );
};
